import { ReactNode } from 'react'
import { MailOutline, Phone } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ContactCard, ContactIcon } from './TwoFactorSupportInfo.style'
import { useSupportContact } from './TwoFactorSupportInfo.utils'

interface SupportContactProps {
  icon: ReactNode
  label: string
  value: string
}

const SupportContact = ({ icon, label, value }: SupportContactProps) => (
  <ContactCard>
    <ContactIcon>{icon}</ContactIcon>
    <div>
      <Typography variant="caption" color="text.primary">
        {label}
      </Typography>
      <Typography variant="subtitle1" color="primary" fontWeight={700}>
        {value}
      </Typography>
    </div>
  </ContactCard>
)

interface TwoFactorSupportInfoProps {
  // Shown below the contacts, each screen has its own
  backButton: ReactNode
}

const TwoFactorSupportInfo = ({ backButton }: TwoFactorSupportInfoProps) => {
  const { t } = useTranslation()
  const { phone, email } = useSupportContact()

  return (
    <Grid container spacing={2}>
      {phone && (
        <Grid item xs={12}>
          <SupportContact
            icon={<Phone fontSize="small" />}
            label={t('twoFactorSupport.callUs')}
            value={phone}
          />
        </Grid>
      )}
      {email && (
        <Grid item xs={12}>
          <SupportContact
            icon={<MailOutline fontSize="small" />}
            label={t('twoFactorSupport.emailUs')}
            value={email}
          />
        </Grid>
      )}
      <Grid item xs={12} container justifyContent="center">
        {backButton}
      </Grid>
    </Grid>
  )
}

export default TwoFactorSupportInfo
